
// adds source parameter to Workday links, from cookie set in back end

// global var allows other dynamically rendered areas of the site
// to use `addSourceToUrl` function to add the URL to outbound links
let globalSource

export default function() {
	const source = getCookie('tths') || 'dlg022'
	if (!validate(source)) return
	globalSource = source

	const links = [...document.querySelectorAll('a')]	
	links.map(link => {
		if (!link.href.includes('workday')) return
		link.href = addSourceToUrl(link.href, globalSource)
	})
}

export function addSourceToUrl(url, sourceValue) {
	if (!sourceValue) return url
	const uri = new URL(url)
	uri.searchParams.append('source', sourceValue)
	return uri.toString()
}

function validate(name) {
	return !!name.match(/^[A-Za-z0-9_]+$/)
}

// from: https://stackoverflow.com/a/25346429
function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}